import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-jurisdiction",
  "use": "icon-jurisdiction-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol viewBox=\"0 0 18 18\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-jurisdiction\">\n<g id=\"icon-jurisdiction_icon\">\n<g id=\"icon-jurisdiction_Group 178035\">\n<rect id=\"icon-jurisdiction_Rectangle 7827\" x=\"0.5\" y=\"0.5\" width=\"17\" height=\"17\" rx=\"1.5\" stroke=\"#777777\" />\n</g>\n<rect id=\"icon-jurisdiction_Rectangle 7828\" x=\"4\" y=\"8.5\" width=\"10\" height=\"1\" fill=\"#777777\" />\n<rect id=\"icon-jurisdiction_Rectangle 7829\" x=\"9.5\" y=\"4\" width=\"10\" height=\"1\" transform=\"rotate(90 9.5 4)\" fill=\"#777777\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/jurisdiction.svg
// module id = 8daG
// module chunks = 103